import { render } from "./tabs-ursa.vue?vue&type=template&id=eb2f6186&ts=true"
import script from "./tabs-ursa.vue?vue&type=script&lang=ts"
export * from "./tabs-ursa.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__